













































































































































































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import * as _ from "lodash";
import { Notification } from "@/store/modules/notifications";
import {
  PayByLinkInfoModel,
  PayByLinkPrepayment,
  ReservationModel,
} from "../types";
import { ServiceType } from "@/shared/models/serviceType";
import { CurrencyConversionService } from "@/shared/currencyConversionService";
import { PaymentQueryViewModel } from "@/shared/models/payment";
import CurrencyDisplay from "@/components/misc/CurrencyDisplay.vue";
import NumericInput from "@/components/misc/NumericInput.vue";
import { ChargeCreditCardsResultModel } from "@/shared/models/chargeCreditCardsResultModel";
import { Getter } from "vuex-class";
import { PaymentGatewayIntegrationEnum, ReservationStatusEnum } from "@/shared/models/enums.type";
import { round } from "@/components/numbers/numberFormatUtils";

@Component({
  components: {
    CurrencyDisplay,
    NumericInput,
  },
})
export default class SendPaymentLinkDialog extends Vue {
  @PropSync("open") isOpen?: boolean;
  @Prop() reservationModel?: ReservationModel;
  @Prop() payByLinkModel?: PayByLinkInfoModel;
  @Prop() serviceTypes?: ServiceType[];
  @Prop() currencyId?: number;
  @Prop() currencyIsoCode?: string;

  currencyConversionService?: CurrencyConversionService;

  @Getter("appParams/tenantPaymentGatewayIntegrationId")
  tenantPaymentGatewayIntegrationId?: number;

  get directChargeAvailable() {
    return (
      this.tenantPaymentGatewayIntegrationId ===
        PaymentGatewayIntegrationEnum.WSPay ||
      this.tenantPaymentGatewayIntegrationId ===
        PaymentGatewayIntegrationEnum.NokumoPay
    );
  }

  get preauthorizeAvailable() {
    return (
      this.tenantPaymentGatewayIntegrationId ===
        PaymentGatewayIntegrationEnum.WSPay ||
      this.tenantPaymentGatewayIntegrationId ===
        PaymentGatewayIntegrationEnum.NokumoPay
    );
  }

  payByLinkAmount = 0;
  payByLink = "";
  isLoading = false;
  get totalServicePrice() {
    const exactValue =
      this.reservationModel?.accomodationUnitTypes.reduce(
        (sum, acc) =>
          sum +
          acc.selectedServices
            .filter(
              (x) =>
                !x.isCityTax ||
                !this.serviceTypes?.find(
                  (x) => x.id == _.first(acc.dayPrices)?.serviceTypeId
                )?.includesCityTax
            )
            .reduce(
              (ssum, s) =>
                ssum +
                (this.currencyConversionService?.convertCurrency(
                  s.grossPrice,
                  s.currencyId,
                  this.currencyId ?? s.currencyId
                ) ?? s.grossPrice),
              0
            ),
        0
      ) || 0;

    return Math.round(exactValue * 100) / 100 + Number.EPSILON;
  }

  get totalUnitPrices() {
    const exactValue =
      (this.reservationModel?.accomodationUnitTypes.reduce(
        (sum, acc) =>
          sum +
          round(
            round(acc.dayPrices.reduce((dsum, d) => dsum + d.price, 0)) *
              (1 - (acc.discountPercent ?? 0) / 100)
          ),
        0
      ) || 0) + this.mergedCityTaxPrice();

    return Math.round(exactValue * 100) / 100 + Number.EPSILON;
  }

  mergedCityTaxPrice() {
    return (
      this.reservationModel?.accomodationUnitTypes.reduce(
        (sum, acc) =>
          sum +
          acc.selectedServices
            .filter((x) => x.isCityTax)
            .reduce(
              (ssum, s) =>
                this.serviceTypes?.find(
                  (x) => x.id == _.first(acc.dayPrices)?.serviceTypeId
                )?.includesCityTax === true
                  ? ssum +
                    (this.currencyConversionService?.convertCurrency(
                      s.grossPrice,
                      s.currencyId,
                      this.currencyId ?? s.currencyId
                    ) ?? s.grossPrice)
                  : ssum,
              0
            ),
        0
      ) || 0
    );
  }

  @Watch("isOpen")
  async openWatch(fresh: boolean) {
    if (fresh) {
      this.payByLink = "";
      this.payByLinkAmount = 0;
    }
  }

  copyTemplate(payByLink: string) {
    navigator.clipboard.writeText(payByLink);

    this.$store.dispatch("showNotification", {
      color: "success",
      message: this.$t("LinkCopiedToClipboard"),
      timeout: 5000,
    });
  }

  get totalPrice() {
    return this.totalUnitPrices + this.totalServicePrice;
  }

  get prepaymentsTotalAmount() {
    return this.payByLinkModel?.prepayments.reduce(
      (sum, prepayment) => sum + prepayment.amount,
      0
    );
  }

  get totalPaidAmount() {
    //TODO: (borna) this is old, but we should probably exclude payments for non-guest financial documents (owners invoices, commission invoices, etc)
    return this.payByLinkModel?.payments.reduce(
      (sum, payment) => sum + (payment.amount ?? 0),
      0
    );
  }

  get totalDueAmount() {
    return this.totalPrice - (this.totalPaidAmount ?? 0);
  }

  prepaymentFieldValue(prepayment: PayByLinkPrepayment) {
    return (
      this.$n(prepayment.amount, {
        style: "currency",
        currency: this.currencyIsoCode,
        currencyDisplay: "code",
      }) +
      " (" +
      this.$d(new Date(prepayment.dueDate)) +
      ")"
    );
  }

  paymentFieldValue(payment: PaymentQueryViewModel) {
    return (
      this.$n(payment.amount ?? 0, {
        style: "currency",
        currency: this.currencyIsoCode,
        currencyDisplay: "code",
      }) +
      " (" +
      payment.paymentMeansName +
      ") - " +
      this.$d(new Date(payment.paymentDate))
    );
  }

  sendPayByLinkEmail() {
    const model = [
      {
        reservationId: this.reservationModel?.id,
        reservationHolderId: this.reservationModel?.customerId,
        amount: this.payByLinkAmount,
        currencyId: this.currencyId,
      },
    ];
    this.isLoading = true;
    this.axios
      .post("/reservations/SendPayByLink", {
        ReservationSendByLinkRequestViewModels: model,
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("Message.SendSuccess"),
          timeout: 5000,
          localize: true,
        } as Notification);
      })
      .finally(() => {
        this.isLoading = false;
        this.payByLinkAmount = 0;
        this.isOpen = false;
      });
  }

  getPayByLinkEmail() {
    const model = {
      reservationId: this.reservationModel?.id,
      reservationHolderId: this.reservationModel?.customerId,
      amount: this.payByLinkAmount,
      currencyId: this.currencyId,
    };
    this.isLoading = true;
    this.axios
      .post("/reservations/GetPayByLink", {
        ReservationSendByLinkRequestViewModel: model,
      })
      .then((res) => {
        this.payByLink = res.data;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  
  chargeCreditCardConfirmation() {
    const value = this.$n(this.payByLinkAmount, {
      style: "currency",
      currency: this.currencyIsoCode,
      currencyDisplay: "code",
    });

    this.$store.dispatch("showNotification", {
      color: "warning",
      message: this.$t("Reservation.ChargeCreditCard.Confirmation", {
        value: value,
      }),
      actions: [
        {
          text: this.$t("Yes"),
          fun: () => {
            this.chargeCreditCard(false);
            return true;
          },
        },
        this.reservationModel?.statusId == ReservationStatusEnum.Hold
        ? { 
          text: this.$t("YesAndConfirmReservation"),
          fun: () => {
            this.chargeCreditCard(true);
            return true;
          },
        } 
        : null,
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ].filter(Boolean),
      timeout: 30000,
    } as Notification);
  }

  chargeCreditCard(confirmReservation: boolean | null = null){
    const model = [
      {
        reservationId: this.reservationModel?.id,
        amount: this.payByLinkAmount,
        currencyId: this.currencyId,
        changeReservationStatusToConfirmed: confirmReservation,
      },
    ];
    this.isLoading = true;
    this.axios
      .post<ChargeCreditCardsResultModel>("/reservations/ChargeCreditCards", {
        chargeCreditCardModels: model,
      })
      .then((res) => {
        if (res.data.success) {
          const value = this.$n(this.payByLinkAmount, {
            style: "currency",
            currency: this.currencyIsoCode,
            currencyDisplay: "code",
          });
          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("Reservation.ChargeCreditCard.Success", {
              value: value,
            }),
            timeout: 5000,
            localize: true,
          } as Notification);

          if (
            res.data.successes.find(
              (e) =>
                e.reservationId === this.reservationModel?.id && !!e.paymentId
            )
          ) {
            this.$store.dispatch("showNotification", {
              color: "success",
              message: this.$t("Payment.SaveSuccess"),
              timeout: 5000,
              localize: true,
            } as Notification);
          }

          // close modal on success
          this.payByLinkAmount = 0;
          this.isOpen = false;
        } else {
          this.$store.dispatch("showNotification", {
            color: "error",
            message:
              this.$t("Reservation.ChargeCreditCard.Error") +
              ` ${this.$t(res.data.errors[0].errorMessage)}`,
            timeout: 10000,
            localize: true,
          } as Notification);
        }
      })
      .finally(() => {
        this.isLoading = false;     
        this.$emit("refresh");
      });
  }

  preauthorizeCreditCardConfirmation() {
    const value = this.$n(this.payByLinkAmount, {
      style: "currency",
      currency: this.currencyIsoCode,
      currencyDisplay: "code",
    });

    this.$store.dispatch("showNotification", {
      color: "warning",
      message: this.$t("Reservation.PreauthorizeCreditCard.Confirmation", {
        value: value,
      }),
      actions: [
        {
          text: this.$t("Continue"),
          fun: () => {
            this.preauthorizeCard();
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }

  preauthorizeCard() {
    const model = [
      {
        reservationId: this.reservationModel?.id,
        amount: this.payByLinkAmount,
        currencyId: this.currencyId,
      },
    ];
    this.isLoading = true;

    this.axios
      .post("/reservations/PreauthorizeCreditCard", {
        preauthorizeCreditCardModels: model,
      })
      .then((res) => {
        if (res.data.success) {
          const value = this.$n(this.payByLinkAmount, {
            style: "currency",
            currency: this.currencyIsoCode,
            currencyDisplay: "code",
          });
          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("Reservation.PreauthorizeCreditCard.Success", {
              value: value,
            }),
            timeout: 5000,
            localize: true,
          } as Notification);

          // close modal on success
          this.payByLinkAmount = 0;
          this.isOpen = false;
        } else {
          this.$store.dispatch("showNotification", {
            color: "error",
            message:
              this.$t("Reservation.PreauthorizeCreditCard.Error") +
              ` ${this.$t(res.data.errors[0].errorMessage)}`,
            timeout: 10000,
            localize: true,
          } as Notification);
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
